module.exports = __webpack_public_path__ + "build/desktop/img/icon_point_select.3317734d85f4ec89d2520d08dd713384.png";